<template>
  <div class="MaSelect ub ub-ac">
    <span class="label_name">{{ labelName }}:</span>
    <span class="ub-f1">
      <el-select
        ref="input"
        size="mini"
        v-model="value1"
        filterable
        :disabled="disabled ? Enable : false"
        placeholder="请选择"
        @focus="DoFocus"
        @change="changeSelecet"
        @keypress="enterDown"
      >
        <el-option
          v-for="item in options"
          :key="item.BaseNo"
          :label="item.Name"
          :value="item.BaseNo"
        ></el-option>
      </el-select>
    </span>
    <span
      v-if="MultipleAccounts"
      class="label_name"
      style="width: 30px; text-align: center"
    >
      <i slot="suffix" class="el-icon-search" @click="manyShow"></i>
    </span>
  </div>
</template>  

<script>
import tool from "@/utils/tool"; //本地缓存存取
export default {
  // 注册组件
  components: {
    // TreeTable,//树状图table表组件
  },
  data() {
    return {
      value1: "",
      options: [],
      selctData: {},
      btn_disabled: this.disabled,
      btn_Enable: this.Enable,
      MultipleAccounts: this.Multipleaccounts,
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    Enable: {
      type: Boolean,
      default: false,
    },
    Multipleaccounts: {
      type: Boolean,
      default: false,
    },
    labelName: {
      type: String,
      default: "银行账户",
    },
    value: [String, Number, Object],
  },
  watch: {
    value: {
      handler(newName, oldName) {
        this.value1 = newName.KtypeId;
        this.selctData = newName;
      },
      immediate: true,
    },
  },
  methods: {
    // 点击放大镜
    manyShow() {
      this.$emit("manyShow");
    },
    // 请求table表格数据
    InitTable() {
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        type: 4, //查询的数据类型 0商品单位 1商品颜色 2商品尺码 3商品厂家4 账户
        style: 1,
        IsDir: 0, //只显示末端银行账户类
        pagesize: 100, //每页条数，当前写死了
      };
      this.request
        .post("/index/Settings/search_other", {
          jparams: JSON.stringify(params),
        })
        .then((res) => {
          // 接收后端发送回来的数据
          // console.log(res);
          this.options = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取焦点清空数据
    DoFocus() {
      this.value1 = "";
      this.selctData = {};
    },
    // 选择改变时触发
    changeSelecet(val) {
      this.selctData = this.options.find((item) => {
        if (item.BaseNo == val) {
          return item;
        }
      });
      this.selctData = {
        FullName: this.selctData.FullName,
        KtypeId: this.selctData.BaseNo,
      };
      this.$emit("dateChange", this.selctData);
      this.$emit("nextFocus");
    },
    // 按enter键
    enterDown() {
      this.$refs.input.blur();
      this.$emit("nextFocus");
    },
  },
  created() {
    this.InitTable();
  },
};
</script>

<style lang="less">
.MaSelect {
  height: 28px;
  color: #666;
  border: 1px solid #d6e2ed;
  border-radius: 5px;
  padding: 0 5px;
  box-sizing: border-box;
  overflow: hidden;
  .label_name {
    height: 100%;
    line-height: 28px;
    font-size: 12px;
    color: inherit;
    font-weight: bold;
  }
  span,
  .label_name {
    display: block;
  }
  .input_sty {
    position: relative;
    -webkit-box-flex: 1;
    box-flex: 1;
    display: block;
    height: 100%;
  }
  .el-input__inner,
  .el-input__inner:hover {
    border-color: #fff;
  }
  .el-select .el-input.is-focus .el-input__inner {
    border-color: rgba(0, 0, 0, 0);
  }
  .date_sty {
    width: 100%;
  }
}
.el-select .el-input__inner:focus {
  border-color: rgba(0, 0, 0, 0);
}
</style>


// WEBPACK FOOTER //
// src/components/Input/MaSelect/MaSelect.vue